import React from 'react'
import { ItemContainer, ItemBoxIcon, ItemName, ItemQtde } from './styles'
import { MdAccountCircle } from 'react-icons/md'
import moment from 'moment'

export default function ElementItem({ values, onSelect }) {
  return (
    <ItemContainer onClick={() => onSelect(values.conversaId)}>
      <ItemBoxIcon>
        <MdAccountCircle size={34} color="#DFE5E7" />
      </ItemBoxIcon>
      <ItemName>{values.cliNome}</ItemName>
      <ItemQtde>{moment(values.dhCadastro).format('DD/MMM HH:mm')}</ItemQtde>
    </ItemContainer>
  )
}
